<template>
  <div class="prostatic">
    <el-card class="box-card tablecard" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <el-row>
          <span><i class="fa fa-gift fs14" /> Summary statistics ({{timestr}}) </span>
        </el-row>
      </div>
      <div>
        <div class="searchbox">
          <el-input placeholder="截止年份" v-model="endyearval" clearable>
            <el-button slot="append" icon="el-icon-search" @click="handleSearchyear"></el-button>
          </el-input>
        </div>
        <div v-show="isshowsummary">
          <p class="textLeft">截止到{{yearstrshow}}-12-31：</p>
          <ul class="textLeft"> 
            <li>总项目数为{{statData[13].object_num}}个，其中已经提交的项目数为{{statData[12].object_num}}个，公开的项目数为{{statData[11].object_num}}个，总的数据量为{{statData[16].object_num}}，已经提交的数据量为{{statData[15].object_num}}，公开的数据量为{{statData[14].object_num}}；</li> 
            <li>注册用户有{{statData[0].object_num}}个，来自于{{statData[1].object_num}}个不同的国家，{{statData[2].object_num}}个不同的单位；</li> 
            <li>已公开的项目包含{{statData[7].object_num}}个物种，{{statData[9].object_num}}个细胞类型，{{statData[10].object_num}}种疾病和{{statData[8].object_num}}个组织器官；</li> 
            <li>与国际蛋白质组数据联盟ProteomeXchange交换数据{{statData[5].object_num}}批；</li> 
            <li>通过平台发表了{{statData[6].object_num}}篇论文；</li> 
            <li>访问量{{statData[3].object_num}}次，点击量{{statData[4].object_num}}次。</li>
          </ul>
        </div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics by year </span>
      </div>
      <div>
        <div class="searchbox">
          <el-input placeholder="Provide one year" v-model="yearval" clearable>
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
        <ul class="textLeft" v-show="isShow">
          <li>{{yearstaArr[0].object_class}}年总项目为{{yearstaArr[11].object_num}}个，这些项目的数据量为{{yearstaArr[12].object_num}}；</li> 
          <li>{{yearstaArr[0].object_class}}年新增的已提交项目为{{yearstaArr[0].object_num}}个，这些项目的数据量为{{yearstaArr[1].object_num}}；</li> 
          <li>{{yearstaArr[0].object_class}}年新增的已公开项目为{{yearstaArr[2].object_num}}个，这些项目的数据量为{{yearstaArr[3].object_num}}；</li> 
          <li>{{yearstaArr[0].object_class}}年新增用户{{yearstaArr[4].object_num}}个，来自于{{yearstaArr[5].object_num}}个不同的国家，{{yearstaArr[6].object_num}}个不同的单位；</li> 
          <li>{{yearstaArr[0].object_class}}年与国际蛋白质组数据联盟ProteomeXchange交换数据{{yearstaArr[7].object_num}}批；</li> 
          <li>{{yearstaArr[0].object_class}}年通过平台发表了{{yearstaArr[8].object_num}}篇论文；</li> 
          <li>{{yearstaArr[0].object_class}}年访问量{{yearstaArr[9].object_num}}次，点击量{{yearstaArr[10].object_num}}次。</li>
        </ul>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Classified statistics </span>
      </div>
      <div class="statlist">
        <ul class="textLeft">
          <li v-for="(item, index) in staList" :key="index">
            <a class="pointer" :title="item.linkto"  @click="handleLink(item.linkto)">{{index+1}}. {{item.title}}</a>
          </li>
        </ul>
        <!-- <ol class="textLeft"> 
          <a class="pointer" v-for="(item, index) in staList" :key="index" @click="handleLink(item.linkto)">
            <li>{{item.title}}</li>
          </a>
        </ol> -->
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics </span>
      </div>
      <div>
        <el-table
          :data="statDatatb"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="id"
            label="#"
            width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="条目"
            width="210"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="num_all"
            align="right"
            label="数量"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="size_all"
            align="right"
            label="数据量（TB）"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="num_own"
            align="right"
            label="自主产出的数量"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="size_own"
            align="right"
            label="数据量（TB）"
            header-align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getBasicStat, getStatProjectGrid, getSysVal } from '@/api'
import echarts from 'echarts'
export default {
  name: 'prostatic',
  data() {
    return {
      staList: [{
        linkto: '/statistics',
        title: '已发布项目数饼图（按物种、仪器、疾病、组织器官、细胞类型统计）'
      }, {
        linkto: '/admin/statistics/statisticsall',
        title: '项目数和数据量列表（按物种、仪器、疾病、组织器官、细胞类型统计）'
      }, {
        linkto: '/admin/statistics/sap',
        title: '新增项目数柱状图、折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/sp',
        title: '累加项目数折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/sapf',
        title: '新增数据量柱状图、折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/spf',
        title: '累加数据量折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/visits',
        title: '新增、累加访问量折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/hits',
        title: '新增、累加点击量折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/sdfbd',
        title: '新增下载数据量、累加下载数据量折线图（按周、月、年统计）'
      }, {
        linkto: '/admin/statistics/dbp',
        title: '已下载次数和数据量列表（按项目统计）'
      }, {
        linkto: '/admin/statistics/pbc',
        title: '已提交项目数和数据量列表（按国家统计）'
      }, {
        linkto: '/admin/statistics/ppbc',
        title: '已发布项目数和数据量列表（按国家统计）'
      }, {
        linkto: '/admin/statistics/pbi',
        title: '已提交项目数和数据量列表（按单位统计）'
      }, {
        linkto: '/admin/statistics/ppbi',
        title: '已发布项目数和数据量列表（按单位统计）'
      }, {
        linkto: '/admin/statistics/pbj',
        title: '已发表论文列表（按期刊统计项目）'
      }, {
        linkto: '/admin/statistics/pbjf',
        title: '公开项目和已提交项目数柱状图、折线图（按年统计）'
      }, {
        linkto: '/admin/statistics/pwnl',
        title: '公开项目文件数据量及文件数列表'
      }],
      yearval: '',
      ajax_data_year: {
        filters: [{
          item: "objecttype",
          equals: "11"
        }, {
          item: "objectclass",
          equals: "init"
        }]
        // order: {
        //   item: "object_class",
        //   type: "descending"
        // }
      },
      ajax_data_stat: {
        filters: [{
          item: "objecttype",
          equals: "12"
        },{
          item: "objectclass",
          equals: ''
        }]
      },
      yearstaArr: [],
      isShow: true,
      statData: [],
      ajax_data_stattb: {
        search:{
          stat_type: '13'
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: '',
          type: ''
        }
      },
      tableData: [{
        id: '项目',
        name: '总的项目'
      }, {
        id: '项目',
        name: '已提交的项目'
      }, {
        id: '项目',
        name: '已提交的公共项目'
      }, {
        id: '子项目',
        name: '总的子项目'
      }, {
        id: '子项目',
        name: '已提交的子项目'
      }, {
        id: '子项目',
        name: '已提交的公共子项目'
      }, {
        id: '文件',
        name: '总的文件'
      }, {
        id: '文件',
        name: '已提交的项目包含的文件'
      }, {
        id: '文件',
        name: '已提交的公共项目包含的文件'
      }],
      statDatatb:[],
      timestr: '',
      ajax_datatime: {},
      endyearval: '',
      yearstr: '',
      isshowsummary: true,
      yearstrshow: ''
    }
  },
  watch: {
    // timestr: {}
  },
  mounted() {
    getStatProjectGrid(this.ajax_data_stattb).then(res => {
      let newData = res.result
      newData.forEach((val, index) => {
        val.size_all = this.handleFilesize3(val.size_all)
        val.size_own = this.handleFilesize3(val.size_own)
      })
      // console.log(this.tableData[0])
      // console.log(newData[0])
      let dataarr = newData[0]
      let testarr = []
      testarr[0] = { ...this.tableData[0], ...newData[0] }
      testarr[1] = { ...this.tableData[1], ...newData[5] }
      testarr[2] = { ...this.tableData[2], ...newData[2] }
      testarr[3] = { ...this.tableData[3], ...newData[8] }
      testarr[4] = { ...this.tableData[4], ...newData[7] }
      testarr[5] = { ...this.tableData[5], ...newData[4] }
      testarr[6] = { ...this.tableData[6], ...newData[1] }
      testarr[7] = { ...this.tableData[7], ...newData[6] }
      testarr[8] = { ...this.tableData[8], ...newData[3] }
      this.statDatatb = testarr
      // // this.tableData[0].push(newData[0])
      // console.log(testarr)
      // this.tableData = res.result
    })
  },
  created() {
    getSysVal(this.ajax_datatime).then(res => {
      // const parts = res.result[0].sysdate.split(" ")
      // console.log(parts)
      this.timestr = res.result[0].sysdate
      let timearr = this.timestr.split("-")
      this.yearstr = timearr[0]
      this.yearstrshow = this.yearstr
      this.ajax_data_stat.filters[1].equals = this.yearstr
      getBasicStat(this.ajax_data_stat).then(res => {
        let newData = res.result
        newData[16].object_num = this.handleFilesize2(newData[16].object_num)
        newData[15].object_num = this.handleFilesize2(newData[15].object_num)
        newData[14].object_num = this.handleFilesize2(newData[14].object_num)
        newData[3].object_num = this.formatWithSeparator(newData[3].object_num)
        newData[4].object_num = this.formatWithSeparator(newData[4].object_num)
        this.statData = newData
      })
    })
  
    getBasicStat(this.ajax_data_year).then(res => {
      console.log(res.result)
      if(res.result.length == 0) {
        this.isShow = false
      } else {
        res.result[1].object_num = this.handleFilesize2(res.result[1].object_num)
        res.result[3].object_num = this.handleFilesize2(res.result[3].object_num)
        res.result[9].object_num = this.formatWithSeparator(res.result[9].object_num)
        res.result[10].object_num = this.formatWithSeparator(res.result[10].object_num)
        res.result[12].object_num = this.handleFilesize2(res.result[12].object_num)
        this.yearstaArr = res.result
        this.isShow = true
      }
    })
  },
  methods: {
    handleSearch() {
      if(this.yearval == "") {
        this.ajax_data_year.filters[1].equals = 'init'
      } else {
        this.ajax_data_year.filters[1].equals = this.yearval
      }
      getBasicStat(this.ajax_data_year).then(res => {
        if(res.result.length == 0) {
          this.isShow = false
        } else {
          res.result[1].object_num = this.handleFilesize2(res.result[1].object_num)
          res.result[3].object_num = this.handleFilesize2(res.result[3].object_num)
          res.result[9].object_num = this.formatWithSeparator(res.result[9].object_num)
          res.result[10].object_num = this.formatWithSeparator(res.result[10].object_num)
          res.result[12].object_num = this.handleFilesize2(res.result[12].object_num)
          this.yearstaArr = res.result
          this.isShow = true
        }
      })
    },
    handleLink(param) {
      this.$router.push({path: param})
      // window.open(param, '_blank');
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = 0 +'K';
      } else if (fileSize < 1024) {
        fileSize = fileSize.toFixed(2) + 'K';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize =  (fileSize / 1024).toFixed(2)+ 'M'
      } else {
        fileSize =   (fileSize / 1024 / 1024).toFixed(2)
          + 'G'
      }
      return fileSize
    },
    handleFilesize2(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = 0 +'KB';
      } else if (fileSize < 1024) {
        fileSize = fileSize.toFixed(2) + 'KB';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize = (fileSize / 1024).toFixed(2)+ 'M'
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024 * 1024) {
        fileSize = (fileSize / 1024 / 1024).toFixed(2)+ 'GB'
      } else {
        fileSize = (fileSize / 1024 / 1024 / 1024).toFixed(2)
          + 'TB'
      }
      return fileSize
    },
    handleFilesize3(param) {
      let fileSize = param
      if (fileSize == 0 || fileSize == null) {
        fileSize = 0
      } else if (fileSize < 1024) {
        fileSize = fileSize.toFixed(2)
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize = (fileSize / 1024).toFixed(2)
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024 * 1024) {
        fileSize = (fileSize / 1024 / 1024).toFixed(2)
      } else {
        fileSize = (fileSize / 1024 / 1024 / 1024).toFixed(2)
      }
      return fileSize
    },
    formatWithSeparator(number) {
      return new Intl.NumberFormat().format(number)
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    handleSearchyear() {
      // const currentYear = new Date().getFullYear();
      if(this.endyearval != '') {
        this.ajax_data_stat.filters[1].equals = this.endyearval
        this.yearstrshow = this.endyearval
      } else {
        this.ajax_data_stat.filters[1].equals = this.yearstr
        this.yearstrshow = this.yearstr
      }
      getBasicStat(this.ajax_data_stat).then(res => {
        if(res.result.length == 0) {
          this.isshowsummary = false
        } else {
          let newData = res.result
          newData[16].object_num = this.handleFilesize2(newData[16].object_num)
          newData[15].object_num = this.handleFilesize2(newData[15].object_num)
          newData[14].object_num = this.handleFilesize2(newData[14].object_num)
          newData[3].object_num = this.formatWithSeparator(newData[3].object_num)
          newData[4].object_num = this.formatWithSeparator(newData[4].object_num)
          
          this.statData = newData
          this.isshowsummary = true
        }
        
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.prostatic {
  .searchbox {
    width: 40%;
    margin-left: 25px;
  }
  .statlist ul li {
    list-style:none;
    margin-bottom: 5px;
  }
} 
</style>
